import { render, staticRenderFns } from "./buttonsave.vue?vue&type=template&id=5d50d6a2&"
import script from "./buttonsave.js?vue&type=script&lang=js&"
export * from "./buttonsave.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d50d6a2')) {
      api.createRecord('5d50d6a2', component.options)
    } else {
      api.reload('5d50d6a2', component.options)
    }
    module.hot.accept("./buttonsave.vue?vue&type=template&id=5d50d6a2&", function () {
      api.rerender('5d50d6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/buttons/buttonsave.vue"
export default component.exports